import React from 'react';
import Ajax from '../../../../utils/Ajax';
import { useTranslation } from 'react-i18next';
import BookingsAutocomplete from './BookingsAutocomplete';

const HotelNameAutocomplete = ({ value, id, onChange }) => {
    const { t } = useTranslation();

    const fetchHotels = (search) => {
        if (!search || search.length < 2) {
            return;
        }

        return new Promise((resolve, reject) => {
            Ajax.searchAutocomplete(search, {
                type: 'hotel',
                search_limit: 10,
                search_hotels: true,
            })
                .done((res) => resolve(res.data))
                .fail((err) => reject(err));
        });
    };

    return (
        <BookingsAutocomplete
            id={id}
            value={value ? { name: value } : null}
            onChange={onChange}
            fetchOptions={fetchHotels}
            getOptionLabel={(opt) => opt.name || ''}
            isOptionEqualToValue={(option, val) => option?.name === val?.name}
            placeholder={t('AdvancedFilters.FindByHotelNamePlaceholder')}
			mapValue={(opt) =>
				opt
					? { hotel_id: opt.hotel_id, hotel_name: opt.name }
					: { hotel_id: null, hotel_name: '' }
			}
        />
    );
};

export default HotelNameAutocomplete;